export default [
     // corpstandart
  
  { // new corpstandart url
    path: '/company/corpstandart/:id/new',
    name: 'NewCorpstandart',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/corpstandart/new_corpstandart.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  { // new corpstandart url
    path: '/company/corpstandart/:id/:id_corpstandart/edit',
    name: 'EditCorpstandart',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/corpstandart/edit_corpstandart.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  

  { // user passport corpstandart
    path: '/user/corpstandart/:id',
    name: 'Usercorpstandart',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/user_passport/user_corpstandarts.vue'),
    meta: { 
      requiresAuth: true
    }
  },
]